import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { useShellBodyResize } from './shellBodyResize/ShellBodyResizeContext';
const handleIsDraggingCss = "h1sbxm1h";
const resizeHandleCss = "rafmcta";

/**
 * Vertical splitter between the center column and `#shell-side-panel`.
 * Only rendered when the side panel is open on desktop.
 */
export const SidePanelResizeHandle = () => {
  const {
    enabled,
    isDragging,
    resizeHandleProps
  } = useShellBodyResize();
  if (!enabled) {
    return null;
  }
  const {
    onPointerDown,
    ...ariaProps
  } = resizeHandleProps;
  return <BareButton type="button" className={classNames(resizeHandleCss, {
    [handleIsDraggingCss]: isDragging
  })} aria-label="Resize side panel" onPointerDown={onPointerDown} {...ariaProps} />;
};

require("./SidePanelResizeHandle.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SidePanelResizeHandle.tsx");